module.exports = __webpack_public_path__ + "media/images/siq-shield-banner-50b56544dd9efbf4dddd1a9653e5129a.png";